import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { LookupAutocompleteData } from './lookup-autocomplete-data';
import { DataService } from '../ngx-completer/services/data.service';
import { CompleterItem } from '../ngx-completer/model/completer-item';

@Component({
  selector: 'lookup-autocomplete',
  styles: [
      `
          .searchBtn {
              display: block;
              width: 20px;
              height: 22px;
              background: url(../../../../assets/images/btn_on_lookup.png) no-repeat center center;
              cursor: pointer;
          }
    `
  ],
  template: `
    <ngx-completer
        [(ngModel)]="filter"
        (selected)="onNewFilterSelected($event)"
        [initialValue]="filter"
        [datasource]="dataSource"
        [minSearchLength]="2"
        [textNoResults]="'COMMON.DIALOGS.LOOKUP.TEXT_NO_RESULTS'| translate"
        [textSearching]="'COMMON.DIALOGS.LOOKUP.SEARCHING'| translate"
        placeholder="{{'COMMON.DIALOGS.LOOKUP.SEARCH_FOR_RECORDS'| translate}}"></ngx-completer>
    <a class="searchBtn" href="javascript:void(0)" (click)="search()"></a>
  `
})

export class LookupAutocompleteComponent {
  @Input() filter: string;
  @Output() newFilterSelected: EventEmitter<any> = new EventEmitter();
  public dataSource: DataService;

  constructor(@Inject(LookupAutocompleteData) private autocompleteDataFactory: any) {
    this.dataSource = this.remote('EntityName', 'EntityName');
  }

  onNewFilterSelected(selected: CompleterItem) {
    if (selected) {
      this.search();
    }
  }

  search() {
    this.newFilterSelected.emit(this.filter);
  }

  remote(searchFields: string | null = '', titleField: string | null = ''): LookupAutocompleteData {
    const remoteData = this.autocompleteDataFactory();
    return remoteData
      .searchFields(searchFields)
      .titleField(titleField);
  }
}
